import React from 'react';
import Proforma from './proforma/index';

const ProformaPage = () => {
  return <Proforma />;
};

export default ProformaPage;
